// extracted by mini-css-extract-plugin
export var deleteIcon = "_qm-5";
export var deleteOption = "_qm-3";
export var divider = "_qm-2";
export var downloadIcon = "_qm-4";
export var drawer = "_qm-0";
export var drawerFooter = "_qm-6";
export var drawerOpen = "_qm-1";
export var highlighted = "_qm-7";
export var lighterHighlight = "_qm-8";